// extracted by mini-css-extract-plugin
export default {"backdrop":"Modal_backdrop__sVPQZ","modal":"Modal_modal__yEgVW","slide-down":"Modal_slide-down__BV43q","modal__dark":"Modal_modal__dark__tV+Ou"};